"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "m22.06 14.556 1.672.887a.512.512 0 0 1-.001.901l-11.5 6.098a.49.49 0 0 1-.462 0l-11.5-6.098a.508.508 0 0 1-.269-.45c0-.19.104-.363.269-.45l1.672-.886a.498.498 0 0 1 .675.215.512.512 0 0 1-.212.686l-.823.435L12 21.42l10.419-5.526-.822-.436a.512.512 0 0 1-.212-.686.5.5 0 0 1 .675-.216Zm0-4 1.672.887a.512.512 0 0 1-.001.901l-11.5 6.098a.49.49 0 0 1-.462 0l-11.5-6.098a.508.508 0 0 1-.269-.45c0-.19.104-.363.269-.45l1.672-.886a.498.498 0 0 1 .675.215.512.512 0 0 1-.212.686l-.823.435L12 17.42l10.419-5.526-.822-.436a.512.512 0 0 1-.212-.686.5.5 0 0 1 .675-.216Zm-9.828-8.999 11.5 6a.5.5 0 0 1-.001.886l-11.5 6a.496.496 0 0 1-.462 0l-11.5-6a.5.5 0 0 1 0-.886l11.5-6a.499.499 0 0 1 .463 0ZM12 2.563 1.581 8 12 13.437 22.419 8 12 2.563Z",
    clipRule: "evenodd"
  })]
});